<template>
    <div class="footer-check">
        <!-- <div class="container"> -->
            <div class="footer-format">
                <div class="footer-policy col-md-6">
                    <span>{{infoCompany}}</span>
                </div>
                <div class="footer-info col-md-6">
                    <span><a target="_blank" href="https://www.hongky.com"><img :src="imgLanguage" />{{domain}}</a></span>
                </div>
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
    export default {
        props: {
            lstData: Array
        },
        data() {
            return {
                imgLanguage: window.origin + '/assets/images/language.png',
                domain: '',
                infoCompany: ''
            }
        },
        mounted () {
            if (this.lstData != undefined && this.lstData && Object.keys(this.lstData).length > 0) {
                var objDomain = this.lstData.filter(a => a.key == 'PAGE_CHECKER_DOMAIN');
                if (objDomain && Object.keys(objDomain).length) {
                    this.domain = objDomain[0].value.trim();
                }
                var objInfoCompany = this.lstData.filter(a => a.key == 'PAGE_CHECKER_INFO');
                if (objInfoCompany && Object.keys(objInfoCompany).length) {
                    this.infoCompany = objInfoCompany[0].value.trim();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box-warranty-check { 
        .footer-check{ background: #26a2d6; height: 100px; 
            .footer-format{ display: flex;align-items: center; align-content: center; height: 100%; padding: 0 37.50px;
                .footer-policy { font-family: 'Roboto'; color: #fff; font-size: 13px; line-height: 18px;}
                .footer-info{color: #fff; font-family: 'Roboto'; font-weight: 700; font-size: 17px; line-height: 22px; text-align: right;
                    a{color: #fff; text-decoration-line: underline;}
                    img{width: 20px; margin-right: 5px;}
                }
            }
        }
    }
    @media screen  and (max-width: 767px){
        .box-warranty-check {
            .footer-format{ display: inline-block !important;
                .footer-policy {padding-top: 10px;}
                .footer-info{text-align: left !important; margin-top: 10px !important;}
            }
        }
    }
</style>